import React, { useState } from 'react';

interface Props {
  onAddToSheet3: (row: string[]) => void;
}

const ComboTermForm: React.FC<Props> = ({ onAddToSheet3 }) => {
  const [noticeId, setNoticeId] = useState('');
  const [guid, setGuid] = useState('');
  const [comboTerms, setComboTerms] = useState('');
  const [masterTerms, setMasterTerms] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    let finalGuid = guid;
    let title = '';

    if (!finalGuid && noticeId) {
      try {
        const response = await fetch(`/api/metadata-from-notice-id/${encodeURIComponent(noticeId)}`);
        const result = await response.json();
        if (result.status === 'success') {
          finalGuid = result.guid;
          title = result.title;
        } else {
          alert('Failed to find GUID from Notice ID');
          return;
        }
      } catch (error) {
        console.error('Error fetching metadata:', error);
        alert('Error fetching metadata');
        return;
      }
    }

    const comboList = comboTerms.split(',').map(t => t.trim()).filter(Boolean);
    const masterList = masterTerms.split(',').map(t => t.trim()).filter(Boolean);

    if ((!finalGuid && !guid) || comboList.length === 0 || masterList.length === 0) {
      alert('Please provide a GUID or Notice ID, at least one combo term, and one master term');
      return;
    }

    const paddedCombo = [...comboList, '', '', ''].slice(0, 3);
    const paddedMaster = [...masterList, '', '', ''].slice(0, 3);

    const finalRow = [title, finalGuid, '', ...paddedCombo, ...paddedMaster];
    onAddToSheet3(finalRow);

    setNoticeId('');
    setGuid('');
    setComboTerms('');
    setMasterTerms('');
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <input
        type="text"
        placeholder="Notice ID (optional)"
        value={noticeId}
        onChange={(e) => setNoticeId(e.target.value)}
      />
      <input
        type="text"
        placeholder="GUID (optional)"
        value={guid}
        onChange={(e) => setGuid(e.target.value)}
      />
      <input
        type="text"
        placeholder="Combo terms (comma-separated)"
        value={comboTerms}
        onChange={(e) => setComboTerms(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Master terms (comma-separated)"
        value={masterTerms}
        onChange={(e) => setMasterTerms(e.target.value)}
        required
      />
      <button type="submit">Add Combo Term</button>
    </form>
  );
};

export default ComboTermForm;
